import { interactionState } from '../state/interaction-state.js';

/**
 * @typedef {import('../types/jsdoc-types.js').ReactiveControllerHost} ReactiveControllerHost
 */

export class InteractionStateController {
  /** @param {ReactiveControllerHost} host */
  constructor(host) {
    this.host = host;
    this._unsubscribe = null;
    host.addController(this);
  }

  get state() {
    return interactionState;
  }

  hostConnected() {
    interactionState.reset();
    this._unsubscribe = interactionState.subscribe(() => {
      this.host.requestUpdate();
    });
  }

  hostDisconnected() {
    this._unsubscribe?.();
    this._unsubscribe = null;
  }
}
